import { render } from "./BarChartGrup.vue?vue&type=template&id=c4844888"
import script from "./BarChartGrup.vue?vue&type=script&lang=js"
export * from "./BarChartGrup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__